import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

Builder.registerComponent(
  dynamic(() => import('./components/Counter/Counter')),
  {
    name: 'Counter',
    inputs: [
      {
        name: 'initialCount',
        type: 'number',
      },
    ],
  },
);

Builder.registerComponent(
  dynamic(() => import('./components/Home/HomepageV2/BrandLogos')),
  {
    name: 'BrandLogos',
  },
);

Builder.registerComponent(
  dynamic(() => import('./components/Home/HomepageV2/TextWithHighlight')),
  {
    name: 'TextWithHighlight',
  },
);

Builder.registerComponent(
  dynamic(() => import('./components/Partners/FrequentlyAskedQuestions')),
  {
    name: 'FrequentlyAskedQuestions',
  },
);

Builder.registerComponent(
  dynamic(() => import('./components/Common/LandingPage/MarkingMoneyBrand')),
  {
    name: 'MarkingMoneyBrand',
    inputs: [
      {
        name: 'buttonText',
        type: 'string',
        required: false,
      },
    ],
  },
);
